var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "개인정보 및 이력서 관리",
      "topBtn": ""
    }
  }, [_c('template', {
    slot: "topBtn"
  }, [_c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-btn', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mode == 'view',
      expression: "mode == 'view'"
    }],
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function ($event) {
        _vm.mode = 'form';
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 수정하기 ")])], 1), _c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-btn', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mode == 'form',
      expression: "mode == 'form'"
    }],
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.mode = 'view';
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 취소하기 ")])], 1)], 1), _c('template', {
    slot: "contents"
  }, [_c('resume-personal-information', _vm._b({
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-personal-information', {
    mode: _vm.mode
  }, false)), _c('resume-name', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-name', {
    mode: _vm.mode
  }, false)), _c('resume-education', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-education', {
    mode: _vm.mode
  }, false)), _c('resume-work-experience', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-work-experience', {
    mode: _vm.mode
  }, false)), _c('resume-hash-tags', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-hash-tags', {
    mode: _vm.mode,
    hashTags: _vm.hashTags
  }, false)), _c('resume-languages', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-languages', {
    mode: _vm.mode
  }, false)), _c('resume-office-skills', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-office-skills', {
    mode: _vm.mode
  }, false)), _c('resume-certifications', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-certifications', {
    mode: _vm.mode
  }, false)), _c('resume-cover-letter', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'resume-cover-letter', {
    mode: _vm.mode
  }, false)), _c('v-slide-y-reverse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mode == 'form',
      expression: "mode == 'form'"
    }]
  }, [_c('v-card-actions', [_c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장하기")])])], 1)])], 1)])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }